// FICHIER : frontend/src/pages/Offres.jsx
import { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import NavLogo from '../components/NavLogo';
import axios from 'axios';

const API = 'https://ark-recruitment-backend.onrender.com/api';

// ── Icônes ──
const IconArrow = () => (
  <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round">
    <path d="M5 12h14M12 5l7 7-7 7"/>
  </svg>
);

// ── Offres de démonstration (affichées si aucune offre publiée en DB) ──
const OFFRES_DEMO = [
  { id:'demo-1',  titre:'Développeur Full Stack',                    salaire:'800k – 1,5M FCFA/mois',  tags:['Télétravail','Tech','React · Node'],        urgence:'Urgent',  annonce_complete:'Rejoignez notre équipe technique pour développer et maintenir notre plateforme de recrutement IA.' },
  { id:'demo-2',  titre:'Analyste Financier Senior',                 salaire:'1M – 2M FCFA/mois',      tags:['Télétravail','Présentiel','Finance'],        urgence:'Normal',  annonce_complete:'Pilotez nos analyses financières et contribuez à la stratégie de croissance de nos clients.' },
  { id:'demo-3',  titre:'Expert Juridique',                          salaire:'1,2M – 2,5M FCFA/mois',  tags:['Télétravail','Droit','Contrats'],            urgence:'Normal',  annonce_complete:'Assurez la conformité juridique et la rédaction de contrats pour nos entreprises partenaires.' },
  { id:'demo-4',  titre:'Expert Python / Intelligence Artificielle', salaire:'900k – 1,5M FCFA/mois',  tags:['Télétravail','IA','Python · ML'],            urgence:'Urgent',  annonce_complete:'Développez et optimisez nos modèles IA pour automatiser et améliorer le processus de recrutement.' },
  { id:'demo-5',  titre:'Responsable RH Senior',                     salaire:'700k – 1,2M FCFA/mois',  tags:['Présentiel','Ressources Humaines'],          urgence:'Normal',  annonce_complete:'Coordonnez les processus RH et accompagnez nos clients dans leur stratégie de recrutement.' },
  { id:'demo-6',  titre:'Comptable & Auditeur Expert',               salaire:'600k – 1M FCFA/mois',    tags:['Télétravail','Présentiel','Audit'],          urgence:'Normal',  annonce_complete:'Gérez la comptabilité et les audits financiers pour garantir la conformité de nos partenaires.' },
];

// ── Composant principal Page Offres ──
export default function Offres() {
  const navigate = useNavigate();

  // ── Détection mobile ──
  const [isMobile, setIsMobile] = useState(window.innerWidth < 768);
  useEffect(() => {
    const handle = () => setIsMobile(window.innerWidth < 768);
    window.addEventListener('resize', handle);
    return () => window.removeEventListener('resize', handle);
  }, []);

  // ── Chargement offres depuis Supabase ──
  const [offres, setOffres] = useState(OFFRES_DEMO);

  useEffect(() => {
    axios.get(`${API}/offres/publiques`).then(res => {
      if (res.data && res.data.length > 0) {
        const formatted = res.data.map(o => ({
          ...o,
          tags: o.tags || [],
          urgence: o.urgence || 'Normal',
          annonce_complete: o.annonce_complete || o.description || '',
        }));
        setOffres(formatted);
      }
    }).catch(() => {});
  }, []);

  // ── État des filtres ──
  const [filtreActif,  setFiltreActif]  = useState('Tous');
  const [urgentOnly,   setUrgentOnly]   = useState(false);
  const [recherche,    setRecherche]    = useState('');

  // ── Tags dynamiques ──
  const TOUS_TAGS = ['Tous', ...new Set(offres.flatMap(o => o.tags || []))];

  // ── Filtrage des offres ──
  const offresFiltrees = offres.filter(o => {
    const matchTag     = filtreActif === 'Tous' || (o.tags || []).includes(filtreActif);
    const matchUrgent  = !urgentOnly || o.urgence === 'Urgent';
    const matchRecherche = recherche === '' ||
      (o.titre || '').toLowerCase().includes(recherche.toLowerCase()) ||
      (o.tags || []).some(t => t.toLowerCase().includes(recherche.toLowerCase()));
    return matchTag && matchUrgent && matchRecherche;
  });

  return (
    <div style={{ background:'var(--bg)', color:'var(--text)', fontFamily:'DM Sans,sans-serif', minHeight:'100vh' }}>

      {/* ── NAVIGATION ── */}
      <nav style={{ position:'sticky', top:0, zIndex:200, display:'flex', alignItems:'center', justifyContent:'space-between', padding: isMobile ? '0 20px' : '0 64px', height:68, background:'var(--nav-bg)', borderBottom:'1px solid var(--border)' }}>
        <NavLogo/>

        {/* Bouton retour landing */}
        <span onClick={() => navigate('/')} style={{ display:'inline-flex', alignItems:'center', gap:6, color:'var(--muted)', fontSize:12, fontFamily:'DM Mono,monospace', cursor:'pointer', letterSpacing:0.5 }}>
          <svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round"><path d="M19 12H5M12 5l-7 7 7 7"/></svg>
          {isMobile ? '' : 'Accueil'}
        </span>
      </nav>

      {/* ── EN-TÊTE PAGE ── */}
      <div style={{ padding: isMobile ? '32px 20px 20px' : '48px 64px 24px', maxWidth:1240, margin:'0 auto' }}>
        <div style={{ display:'inline-flex', alignItems:'center', gap:8, color:'var(--accent2)', fontSize:11, fontWeight:600, letterSpacing:2, textTransform:'uppercase', marginBottom:12 }}>
          <span style={{ width:24, height:1, background:'var(--accent2)', display:'inline-block' }}/> Opportunités
        </div>
        <div style={{ display:'flex', flexDirection: isMobile ? 'column' : 'row', justifyContent:'space-between', alignItems: isMobile ? 'flex-start' : 'center', gap:16 }}>
          <h1 style={{ fontFamily:'Syne,sans-serif', fontSize: isMobile ? 'clamp(22px,6vw,32px)' : 'clamp(24px,2.5vw,36px)', fontWeight:800, lineHeight:1.1, letterSpacing:'-1.5px' }}>
            Toutes les offres disponibles
          </h1>
          {/* Compteur offres */}
          <div style={{ fontFamily:'DM Mono,monospace', fontSize:12, color:'var(--muted)', flexShrink:0 }}>
            {offresFiltrees.length} offre{offresFiltrees.length > 1 ? 's' : ''}
          </div>
        </div>
      </div>

      {/* ── FILTRES ── */}
      <div style={{ padding: isMobile ? '0 20px 20px' : '0 64px 24px', maxWidth:1240, margin:'0 auto' }}>

        {/* Barre de recherche */}
        <div style={{ position:'relative', marginBottom:16 }}>
          <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="var(--muted)" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" style={{ position:'absolute', left:14, top:'50%', transform:'translateY(-50%)' }}>
            <circle cx="11" cy="11" r="8"/><path d="M21 21l-4.35-4.35"/>
          </svg>
          <input
            value={recherche}
            onChange={e => setRecherche(e.target.value)}
            placeholder="Rechercher un poste, une compétence..."
            style={{ width:'100%', background:'var(--bg2)', border:'1px solid var(--border)', padding:'10px 14px 10px 36px', fontSize:13, color:'var(--text)', fontFamily:'DM Sans,sans-serif', outline:'none', borderRadius:8 }}
          />
        </div>

        {/* Filtres tags + urgent */}
        <div style={{ display:'flex', gap:8, flexWrap:'wrap', alignItems:'center' }}>

          {/* Filtre Urgent */}
          <button
            onClick={() => setUrgentOnly(!urgentOnly)}
            style={{ fontSize:11, fontWeight:600, padding:'5px 12px', borderRadius:5, border:`1px solid ${urgentOnly ? 'var(--tag-orange-border)' : 'var(--border)'}`, color: urgentOnly ? 'var(--tag-orange)' : 'var(--muted)', background: urgentOnly ? 'var(--tag-orange-bg)' : 'transparent', cursor:'pointer', fontFamily:'DM Mono,monospace', letterSpacing:0.5 }}
          >
            Urgent
          </button>

          {/* Séparateur */}
          <div style={{ width:1, height:20, background:'var(--border)' }}/>

          {/* Filtres par tags */}
          {TOUS_TAGS.map(tag => (
            <button
              key={tag}
              onClick={() => setFiltreActif(tag)}
              style={{ fontSize:11, fontWeight:500, padding:'5px 12px', borderRadius:5, border:`1px solid ${filtreActif === tag ? 'var(--accent)' : 'var(--border)'}`, color: filtreActif === tag ? 'var(--accent)' : 'var(--muted)', background: filtreActif === tag ? 'var(--accent-08)' : 'transparent', cursor:'pointer', fontFamily:'DM Mono,monospace', letterSpacing:0.5 }}
            >
              {tag}
            </button>
          ))}
        </div>
      </div>

      {/* ── GRILLE DES OFFRES ── */}
      <div style={{ padding: isMobile ? '0 20px 48px' : '0 64px 64px', maxWidth:1240, margin:'0 auto' }}>

        {/* Aucune offre trouvée */}
        {offresFiltrees.length === 0 && (
          <div style={{ textAlign:'center', padding:'60px 20px', color:'var(--muted)', fontFamily:'DM Mono,monospace', fontSize:13, letterSpacing:1 }}>
            Aucune offre ne correspond à votre recherche.
          </div>
        )}

        {/* Cartes offres */}
        <div style={{ display:'grid', gridTemplateColumns: isMobile ? '1fr' : 'repeat(auto-fill,minmax(320px,1fr))', gap:14 }}>
          {offresFiltrees.map(o => (
            <div key={o.id} style={{ background:'var(--bg3)', border:'1px solid var(--border)', borderRadius:'var(--radius)', padding:'20px', display:'flex', flexDirection:'column', gap:12 }}>

              {/* Titre + Salaire */}
              <div style={{ display:'flex', justifyContent:'space-between', alignItems:'flex-start', gap:8, flexWrap:'wrap' }}>
                <div style={{ fontFamily:'Syne,sans-serif', fontSize:14, fontWeight:700, lineHeight:1.35 }}>{o.titre}</div>
                <div style={{ fontFamily:'Syne,sans-serif', fontSize:11, fontWeight:700, color:'var(--accent2)', background:'var(--salary-bg)', padding:'4px 8px', borderRadius:6 }}>{o.salaire}</div>
              </div>

              {/* Tags */}
              <div style={{ display:'flex', gap:6, flexWrap:'wrap' }}>
                {o.urgence === 'Urgent' && (
                  <span style={{ fontSize:11, fontWeight:600, padding:'3px 8px', borderRadius:5, border:'1px solid var(--tag-orange-border)', color:'var(--tag-orange)', background:'var(--tag-orange-bg)' }}>
                    Urgent
                  </span>
                )}
                {(o.tags || []).map(t => (
                  <span key={t} style={{ fontSize:11, fontWeight:500, padding:'3px 8px', borderRadius:5, border:'1px solid var(--border)', color:'var(--tag-default)' }}>{t}</span>
                ))}
              </div>

              {/* Aperçu mission — 2 lignes max */}
              <div style={{ fontSize:12, color:'var(--muted)', lineHeight:1.6, overflow:'hidden', display:'-webkit-box', WebkitLineClamp:2, WebkitBoxOrient:'vertical' }}>
                {o.annonce_complete || o.description || ''}
              </div>

              {/* Bas de carte — bouton postuler */}
              <div style={{ display:'flex', justifyContent:'flex-end', borderTop:'1px solid var(--border)', paddingTop:12, marginTop:'auto' }}>
                <span onClick={() => navigate('/candidature', { state: { offre: o } })} style={{ background:'var(--accent)', color:'#fff', padding:'6px 14px', borderRadius:7, fontSize:12, fontWeight:500, display:'inline-flex', alignItems:'center', gap:6, cursor:'pointer' }}>
                  Postuler <IconArrow/>
                </span>
              </div>

            </div>
          ))}
        </div>
      </div>

    </div>
  );
}